import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import hs from '../../img/homeswitch.jpg'
import hsscr from '../../img/hsscr.jpg'
import hsFont from '../../img/hsFont.jpg'

function Cps() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='container'>
      <MainTitle title={t('hsTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
        <p><Trans i18nKey="hsDDTxt"></Trans></p>
        <figure>
          <img className='image-fluid' src={hsFont} alt="Typescale" />
          <figcaption>Homeswitch font</figcaption>
        </figure>
        <ul className='colors'>
          <li><span className='color' style={{background: "#27282A"}}></span> #27282A</li>
          <li><span className='color' style={{background: "#454648"}}></span> #454648</li>
          <li><span className='color' style={{background: "#0485B5"}}></span> #0485B5</li>
          <li><span className='color' style={{background: "#00AEEF"}}></span> #00AEEF</li>
          <li><span className='color' style={{background: "#DB6E11"}}></span> #DB6E11</li>
          <li><span className='color' style={{background: "#F58220"}}></span> #F58220</li>
          <li><span className='color' style={{background: "#F5F5F5"}}></span> #F5F5F5</li>
        </ul>

        <h2>{t('designSystem')}</h2>
        <p><Trans i18nKey="hsDSTxt"></Trans></p>

        <h2>{t('uxApproach')}</h2>
        <p><Trans i18nKey="hsUXTxt" components={{ul: <ul />, li: <li />}}>
        The primary UX goal was to make smart home technology feel approachable, intuitive, and easy to understand for different types of users — from homeowners to hospitality and office clients. The interface was structured to guide users naturally through services, solutions, and project showcases while reducing information overload.
        <br /><br />Special attention was given to:
        <ul>
          <li>clear content organization</li>
          <li>intuitive navigation flow</li>
          <li>simplified presentation of technical features</li>
          <li>strong call-to-action placement</li>
          <li>modern and accessible layouts</li>
        </ul>
        The experience was designed to balance technical credibility with a clean and premium digital presentation.
        </Trans></p>

        <h2>{t('visualDirection')}</h2>
        <p><Trans i18nKey="hsVDTxt"></Trans></p>

        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={hsscr} alt={t('figmaScr')} />
          <figcaption>{t('hsScrCaption')}</figcaption>
        </figure>

        <h2>{t('finalOutcome')}</h2>
        <p><Trans i18nKey="hsFOTxt"></Trans></p>

        <Link className="btn btn-link btn-inner mt-20" to={"https://homeswitch.hr/hr"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Cps

function ContentOne() {
  return(
    <img className="image-fluid" src={hs} alt="Homeswitch" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('hsMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://homeswitch.hr/hr"} target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
      <p className='problem'><Trans i18nKey="hsMainText2">
        The main problem to solve was: <br/><i>How to best present the conversion of a house, office or hotel into a smart home, smart office or smart hotel.</i>
      </Trans></p>
    </div>
  );
}